import { defineComponent as _defineComponent } from 'vue'
import 'leaflet/dist/leaflet.css';
import 'leaflet';
import {
  LMap,
  LTooltip,
  LTileLayer,
  LCircleMarker,
  LControl,
} from 'vue2-leaflet';
import { MapData, Marker, NoDataException } from '@/models/Maps/mapGenerator';
import { isEmpty } from '@/utils/misc';
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue';
import { LoadingProgrammatic } from 'buefy';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'MapWidget',
  props: {
    getData: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  getData: () => Promise<MapData | null>;
};



const mapRef = ref<LMap | null>(null);
const wrapperRef = ref<HTMLElement | null>(null);
const observer = new ResizeObserver(() => onMapResize());

const isFirstResize = ref(true);
const data = ref<MapData | null>(null);
const markers = ref<Marker[]>([]);
const noData = ref(false);

const { t } = useI18n();

onMounted(async () => {
  if (mapRef.value) {
    mapRef.value!.mapObject.attributionControl.remove();
    observer.observe(mapRef.value!.$el);
  }
});

async function update(): Promise<void> {
  const loading = LoadingProgrammatic.open({
    container: wrapperRef.value,
  });
  try {
    noData.value = false;
    data.value = await props.getData();
    markers.value = data
      .value!.markers.map((marker) => ({
        ...marker,
        color: marker.color ?? '#6a5ffe',
        radius: marker.radius ?? 20,
      }))
      .sort((a, b) => ((a.zIndexOffset ?? 0) > (b.zIndexOffset ?? 0) ? 1 : -1));
    mapRef.value!.mapObject.scrollWheelZoom.enable();
    mapRef.value!.mapObject.dragging.enable();
    mapRef.value!.mapObject.addControl(mapRef.value!.mapObject.zoomControl);
    mapRef.value!.mapObject.doubleClickZoom.enable();
  } catch (e) {
    if (e instanceof NoDataException) {
      noData.value = true;
      markers.value = [];
      mapRef.value!.mapObject.scrollWheelZoom.disable();
      mapRef.value!.mapObject.dragging.disable();
      mapRef.value!.mapObject.zoomControl.remove();
      mapRef.value!.mapObject.doubleClickZoom.disable();
    }
  } finally {
    nextTick(() => {
      fitBounds();
    });
  }
  loading.close();
}

function fitBounds(): void {
  const bounds = markers.value.map((marker) => marker.coordinates);
  if (isEmpty(bounds)) {
    // Coordinates to show the world when no data is available
    const northLatitude = 66;
    const southLatitude = -50;
    const westLongitude = -150;
    const eastLongitude = 170;
    mapRef.value!.mapObject.fitBounds(
      [
        [northLatitude, westLongitude],
        [southLatitude, westLongitude],
        [northLatitude, eastLongitude],
        [southLatitude, eastLongitude],
      ],
      {
        padding: [0.25, 0.25],
      },
    );
  } else {
    mapRef.value!.mapObject.fitBounds(bounds, {
      padding: [0.25, 0.25],
    });
  }
}

function onMapResize() {
  if (isFirstResize.value) {
    isFirstResize.value = false;
    return;
  }

  mapRef.value!.mapObject.invalidateSize();
  fitBounds();
}

onBeforeUnmount(() => {
  if (observer && wrapperRef.value) {
    observer.unobserve(wrapperRef.value);
  }
});
expose({ update });

return { __sfc: true,props, mapRef, wrapperRef, observer, isFirstResize, data, markers, noData, t, update, fitBounds, onMapResize, LMap, LTooltip, LTileLayer, LCircleMarker, LControl }
}

})